import gql from 'graphql-tag'

export const COMMISSION_LIST_ENTRY_DELETE_MUTATION = gql`
    mutation commissionListEntryDelete(
        $id: ID!
    ) {
        commissionListEntryDelete(
            id: $id
        ) {
            status
        }
    }
`
